// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import request from '@/utils/request';
import { isBusiness } from '@/utils/settingMer';
var circleBase = isBusiness ? '/admin/business/circle' : '/admin/platform/circle';

/**
 * 店铺分组关联店铺
 * @param data
 */
export function areaBindMerchantApi(data) {
  return request({
    url: "".concat(circleBase, "/bind/merchant"),
    method: 'post',
    data: data
  });
}

/**
 * 删除店铺分组
 * @param id
 */
export function areaDeleteApi(id) {
  return request({
    url: "".concat(circleBase, "/delete/").concat(id),
    method: 'post'
  });
}

/**
 * 查询店铺分组详情信息
 * @param id
 */
export function areaInfoApi(id) {
  return request({
    url: "".concat(circleBase, "/info/").concat(id),
    method: 'get'
  });
}

/**
 * 获取店铺分组tree结构的列表
 * @param params
 */
export function areaListTreeApi(params) {
  return request({
    url: "".concat(circleBase, "/list/tree"),
    method: 'get',
    params: params
  });
}

/**
 * 查询店铺分组相关店铺
 * @param id
 */
export function areaMerchantApi(id) {
  return request({
    url: "".concat(circleBase, "/merchant/").concat(id),
    method: 'get'
  });
}

/**
 * 店铺分组解绑店铺
 * @param data
 */
export function areaRemoveMerchantApi(data) {
  return request({
    url: "".concat(circleBase, "/remove/merchant"),
    method: 'post',
    data: data
  });
}

/**
 * 新增店铺分组
 * @param data
 */
export function areaSaveApi(data) {
  return request({
    url: "".concat(circleBase, "/save"),
    method: 'post',
    data: data
  });
}

/**
 * 店铺分组状态开关
 * @param id
 */
export function areaStatusApi(id) {
  return request({
    url: "".concat(circleBase, "/status/").concat(id),
    method: 'post'
  });
}
/**
 * 店铺分组状态开关
 * @param id
 */
export function areaIsShowApi(id) {
  return request({
    url: "".concat(circleBase, "/show/").concat(id),
    method: 'post'
  });
}

/**
 * 修改店铺分组
 * @param data
 */
export function areaUpdateApi(data) {
  return request({
    url: "".concat(circleBase, "/update"),
    method: 'post',
    data: data
  });
}

/**
 * 商户主体菜单列表
 * @param params
 */
export function menuAreaListApi(params) {
  var data = {
    menuType: params.menuType,
    //菜单类型:M-目录，C-菜单，A-按钮
    name: params.name,
    //菜单名称
    systemType: params.systemType
  };
  return request({
    url: "/admin/platform/business/menu/list",
    method: 'get',
    params: data
  });
}

/**
 * 商户主体菜单新增
 * @param data
 */
export function menuAreaAdd(data) {
  var systemMenuRequest = data;
  return request({
    url: "/admin/platform/business/menu/add",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 商户主体菜单删除
 * @param id
 */
export function menuAreaDelete(id) {
  return request({
    url: "/admin/platform/business/menu/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 商户主体菜单详情
 * @param id
 */
export function menuAreaInfo(id) {
  return request({
    url: "/admin/platform/business/menu/info/".concat(id),
    method: 'get'
  });
}

/**
 * 商户主体菜单修改
 * @param data
 */
export function menuAreaUpdate(data) {
  var systemMenuRequest = data;
  return request({
    url: "/admin/platform/business/menu/update",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 商户主体菜单修改显示状态
 * @param params
 */
export function menuAreaUpdateShowStatus(params) {
  return request({
    url: "/admin/platform/business/menu/update/show/".concat(params.id),
    method: 'post'
  });
}

// ==================== 商户主体端-父级-主页控制器 ====================

/**
 * 商户主体首页数据
 */
export function businessParentHomeIndexApi() {
  return request({
    url: "/admin/business/statistics/home/index",
    method: 'get'
  });
}

// ==================== 商户主体端-管理员控制器 ====================

/**
 * 删除管理员
 * @param {number} id
 */
export function businessAdminDeleteApi(id) {
  return request({
    url: "/admin/business/admin/delete",
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 后台管理员详情
 * @param {number} id
 */
export function businessAdminInfoApi(id) {
  return request({
    url: "/admin/business/admin/info",
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 管理员分页列表
 * @param {object} params
 */
export function businessAdminListApi(params) {
  return request({
    url: "/admin/business/admin/list",
    method: 'get',
    params: params
  });
}

/**
 * 新增后台管理员
 * @param {object} data
 */
export function businessAdminSaveApi(data) {
  return request({
    url: "/admin/business/admin/save",
    method: 'post',
    data: data
  });
}

/**
 * 修改管理员
 * @param {object} data
 */
export function businessAdminUpdateApi(data) {
  return request({
    url: "/admin/business/admin/update",
    method: 'post',
    data: data
  });
}

/**
 * 修改后台管理员密码
 * @param {object} data
 */
export function businessAdminUpdatePasswordApi(data) {
  return request({
    url: "/admin/business/admin/update/password",
    method: 'post',
    data: data
  });
}

/**
 * 修改后台管理员状态
 * @param {object} params
 */
export function businessAdminUpdateStatusApi(params) {
  return request({
    url: "/admin/business/admin/updateStatus",
    method: 'get',
    params: params
  });
}

// ==================== 商户主体端-管理角色控制器 ====================

/**
 * 删除角色
 * @param {number} id
 */
export function businessRoleDeleteApi(id) {
  return request({
    url: "/admin/business/role/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 角色详情
 * @param {number} id
 */
export function businessRoleInfoApi(id) {
  return request({
    url: "/admin/business/role/info/".concat(id),
    method: 'get'
  });
}

/**
 * 角色分页列表
 * @param {object} params
 */
export function businessRoleListApi(params) {
  return request({
    url: "/admin/business/role/list",
    method: 'get',
    params: params
  });
}

/**
 * 新增角色
 * @param {object} data
 */
export function businessRoleSaveApi(data) {
  return request({
    url: "/admin/business/role/save",
    method: 'post',
    data: data
  });
}

/**
 * 修改角色
 * @param {object} data
 */
export function businessRoleUpdateApi(data) {
  return request({
    url: "/admin/business/role/update",
    method: 'post',
    data: data
  });
}

/**
 * 修改角色状态
 * @param {object} data
 */
export function businessRoleUpdateStatusApi(data) {
  return request({
    url: "/admin/business/role/updateStatus",
    method: 'post',
    data: data
  });
}

// ==================== 商户主体端-结点-主页控制器 ====================

/**
 * 商户主体用户渠道数据
 */
export function businessNodeHomeChannelApi() {
  return request({
    url: "/admin/business/statistics/home/channel",
    method: 'get'
  });
}

/**
 * 商户主体首页数据
 */
export function businessNodeHomeIndexApi() {
  return request({
    url: "/admin/business/statistics/home/index",
    method: 'get'
  });
}

/**
 * 商户主体经营数据
 */
export function businessNodeHomeOperatingDataApi() {
  return request({
    url: "/admin/business/statistics/home/operating/data",
    method: 'get'
  });
}

// ==================== 商户主体端商品分类控制器 ====================

/**
 * 店铺商品分类列表
 */
export function businessProductCategoryListApi() {
  return request({
    url: "/admin/business/store/product/category/list",
    method: 'get'
  });
}
export function businessProductCategoryCacheTree() {
  return request({
    url: "/admin/business/store/product/category/cache/tree",
    method: 'get'
  });
}

// ==================== 商户主体端商品控制器 ====================

/**
 * 商品详情
 * @param {number} id
 */
export function businessProductInfoApi(id) {
  return request({
    url: "/admin/business/product/info/".concat(id),
    method: 'get'
  });
}

/**
 * 商品列表
 * @param {object} params
 */
export function businessProductListApi(params) {
  return request({
    url: "/admin/business/product/list",
    method: 'get',
    params: params
  });
}

/**
 * 商品tabs头部
 */
export function businessProductTabsHeadersApi(params) {
  return request({
    url: "/admin/business/product/tabs/headers",
    method: 'get',
    params: params
  });
}

/**
 * 商品评价列表
 * @param {object} params
 */
export function businessProductReplyListApi(params) {
  return request({
    url: "/admin/business/product/reply/list",
    method: 'get',
    params: params
  });
}

// ==================== 商户主体端店铺控制器 ====================

/**
 * 店铺详情
 * @param {number} id
 */
export function businessMerchantDetailApi(id) {
  return request({
    url: "/admin/business/store/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 店铺列表
 * @param {object} params
 */
export function businessMerchantListApi(params) {
  return request({
    url: "/admin/business/store/list",
    method: 'get',
    params: params
  });
}

/**
 * 新增店铺
 * @param {object} data
 */
export function businessMerchantAddApi(data) {
  return request({
    url: "/admin/business/store/add",
    method: 'post',
    data: data
  });
}

/**
 * 编辑店铺
 * @param {object} data
 */
export function businessMerchantUpdateApi(data) {
  return request({
    url: "/admin/business/store/update",
    method: 'post',
    data: data
  });
}

/**
 * 修改店铺状态
 * @param {number} id
 * @param {object} params
 */
export function businessMerchantUpdateStatusApi(id, params) {
  return request({
    url: "/admin/business/store/update/status/".concat(id),
    method: 'post',
    params: params
  });
}

/**
 * 商户主体后台店铺列表头部数量
 */
export function businessMerchantListHeaderNumApi(params) {
  return request({
    url: "/admin/business/merchant/list/header/num",
    method: 'get',
    params: params
  });
}

/**
 * 获取店铺类型列表
 */
export function businessMerchantTypeListApi() {
  return request({
    url: "/admin/business/merchant/type/list",
    method: 'get'
  });
}

/**
 * 获取店铺分类列表
 */
export function businessMerchantCategoryListApi() {
  return request({
    url: "/admin/business/merchant/category/list",
    method: 'get'
  });
}

// ==================== 商户主体端登录控制器 ====================

/**
 * 获取管理员信息通过token
 */
export function businessGetAdminInfoByTokenApi() {
  return request({
    url: "/admin/business/getAdminInfoByToken",
    method: 'get'
  });
}

/**
 * 获取登录图片
 */
export function businessGetLoginPicApi() {
  return request({
    url: "/admin/business/getLoginPic",
    method: 'get'
  });
}

/**
 * 获取菜单
 */
export function businessGetMenusApi() {
  return request({
    url: "/admin/business/getMenus",
    method: 'get'
  });
}

/**
 * 商户主体端登录
 * @param {object} data
 */
export function businessLoginApi(data) {
  return request({
    url: "/admin/business/login",
    method: 'post',
    data: data
  });
}

/**
 * 登录账号检测
 * @param {object} data
 */
export function businessLoginAccountDetectionApi(data) {
  return request({
    url: "/admin/business/login/account/detection",
    method: 'post',
    data: data
  });
}

/**
 * 登录管理员更新
 * @param {object} data
 */
export function businessLoginAdminUpdateApi(data) {
  return request({
    url: "/admin/business/login/admin/update",
    method: 'post',
    data: data
  });
}

/**
 * 登录管理员更新密码
 * @param {object} data
 */
export function businessLoginAdminUpdatePasswordApi(data) {
  return request({
    url: "/admin/business/login/admin/update/password",
    method: 'post',
    data: data
  });
}

/**
 * 商户主体端退出登录
 */
export function businessLogoutApi() {
  return request({
    url: "/admin/business/logout",
    method: 'get'
  });
}

// ==================== 商户主体端菜单控制器 ====================

/**
 * 商户主体菜单缓存树
 */
export function businessMenuNodeCacheTreeApi() {
  return request({
    url: "/admin/business/menu/cache/tree",
    method: 'get'
  });
}

/**
 * 商户主体菜单缓存树
 */
export function businessMenuParentCacheTreeApi() {
  return request({
    url: "/admin/business/menu/cache/tree",
    method: 'get'
  });
}

/**
 * 商户主体菜单列表
 * @param {object} params
 */
export function businessMenuListApi(params) {
  var data = {
    menuType: params.menuType,
    name: params.name
  };
  return request({
    url: "/admin/business/menu/list",
    method: 'get',
    params: data
  });
}

/**
 * 商户主体菜单新增
 * @param {object} data
 */
export function businessMenuAddApi(data) {
  return request({
    url: "/admin/business/menu/add",
    method: 'post',
    data: data
  });
}

/**
 * 商户主体菜单删除
 * @param {number} id
 */
export function businessMenuDeleteApi(id) {
  return request({
    url: "/admin/business/menu/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 商户主体菜单详情
 * @param {number} id
 */
export function businessMenuInfoApi(id) {
  return request({
    url: "/admin/business/menu/info/".concat(id),
    method: 'get'
  });
}

/**
 * 商户主体菜单修改
 * @param {object} data
 */
export function businessMenuUpdateApi(data) {
  return request({
    url: "/admin/business/menu/update",
    method: 'post',
    data: data
  });
}

/**
 * 商户主体菜单修改显示状态
 * @param {number} id
 */
export function businessMenuUpdateShowStatusApi(id) {
  return request({
    url: "/admin/business/menu/update/show/".concat(id),
    method: 'post'
  });
}

// ==================== 商户主体端订单控制器 ====================

/**
 * 订单详情
 * @param {object} params
 */
export function businessOrderInfoApi(params) {
  return request({
    url: "/admin/business/order/info",
    method: 'get',
    params: params
  });
}

/**
 * 订单列表
 * @param {object} params
 */
export function businessOrderListApi(params) {
  return request({
    url: "/admin/business/order/list",
    method: 'get',
    params: params
  });
}

/**
 * 订单状态数量
 */
export function businessOrderStatusNumApi(params) {
  return request({
    url: "/admin/business/order/status/num",
    method: 'get',
    params: params
  });
}

// ==================== 商户主体端退款订单控制器 ====================

/**
 * 退款订单详情
 * @param {string} refundOrderNo
 */
export function businessRefundOrderDetailApi(refundOrderNo) {
  return request({
    url: "/admin/business/refund/order/detail/".concat(refundOrderNo),
    method: 'get'
  });
}

/**
 * 退款订单列表
 * @param {object} params
 */
export function businessRefundOrderListApi(params) {
  return request({
    url: "/admin/business/refund/order/list",
    method: 'get',
    params: params
  });
}

/**
 * 退款订单状态数量
 */
export function businessRefundOrderStatusNumApi(params) {
  return request({
    url: "/admin/business/refund/order/status/num",
    method: 'get',
    params: params
  });
}

// =========== 商户主体超管角色管理 =========

/**
 * 超管角色分页列表
 * @param {object} params
 */
export function platformBusinessRoleListApi(params) {
  return request({
    url: "/admin/platform/business/role/list",
    method: 'get',
    params: params
  });
}

/**
 * 新增角色
 * @param {object} data
 */
export function platformBusinessRoleSaveApi(data) {
  return request({
    url: "/admin/platform/business/role/save",
    method: 'post',
    data: data
  });
}

/**
 * 修改角色
 * @param {object} data
 */
export function platformBusinessRoleUpdateApi(data) {
  return request({
    url: "/admin/platform/business/role/update",
    method: 'post',
    data: data
  });
}

/**
 * 修改角色状态
 * @param {object} data
 */
export function platformBusinessRoleUpdateStatusApi(data) {
  return request({
    url: "/admin/platform/business/role/updateStatus",
    method: 'post',
    data: data
  });
}

/**
 * 删除角色
 * @param {number} id
 */
export function platformBusinessRoleDeleteApi(id) {
  return request({
    url: "/admin/platform/business/role/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 角色详情
 * @param {number} id
 */
export function platformBusinessRoleInfoApi(id) {
  return request({
    url: "/admin/platform/business/role/info/".concat(id),
    method: 'get'
  });
}

/**
 * 商户主体菜单缓存树
 */
export function platformBusinessMenuNodeCacheTreeApi() {
  return request({
    url: "/admin/platform/business/menu/cache/tree",
    method: 'get'
  });
}

/**
 * 商户主体菜单缓存树
 */
export function conjunctiveDiyApi(data) {
  return request({
    url: "".concat(circleBase, "/conjunctive/diy"),
    method: 'post',
    data: data
  });
}

// ==================== 区域代理后台登录控制器 ====================

/**
 * 获取区域代理管理员信息通过token
 */
export function regionGetAdminInfoByTokenApi() {
  return request({
    url: "/admin/region/getAdminInfoByToken",
    method: 'get'
  });
}

/**
 * 获取区域代理登录图片
 */
export function regionGetLoginPicApi() {
  return request({
    url: "/admin/region/getLoginPic",
    method: 'get'
  });
}

/**
 * 获取区域代理菜单
 */
export function regionGetMenusApi() {
  return request({
    url: "/admin/region/getMenus",
    method: 'get'
  });
}

/**
 * 区域代理后台登录
 * @param {object} data
 */
export function regionLoginApi(data) {
  return request({
    url: "/admin/region/login",
    method: 'post',
    data: data
  });
}

/**
 * 区域代理登录账号检测
 * @param {object} data
 */
export function regionLoginAccountDetectionApi(data) {
  return request({
    url: "/admin/region/login/account/detection",
    method: 'post',
    data: data
  });
}

/**
 * 区域代理后台退出登录
 */
export function regionLogoutApi() {
  return request({
    url: "/admin/region/logout",
    method: 'get'
  });
}

// ==================== 平台端-区域代理管理 ====================

/** 区域管理树形列表 */
export function platformRegionAreaListTreeApi(params) {
  return request({
    url: "/admin/platform/region/area/list/tree",
    method: 'get',
    params: params
  });
}

/** 区域详情 */
export function platformRegionAreaDetailApi(id) {
  return request({
    url: "/admin/platform/region/area/detail/".concat(id),
    method: 'get'
  });
}

/** 新增区域 */
export function platformRegionAreaSaveApi(data) {
  return request({
    url: "/admin/platform/region/area/save",
    method: 'post',
    data: data
  });
}

/** 修改区域 */
export function platformRegionAreaUpdateApi(data) {
  return request({
    url: "/admin/platform/region/area/update",
    method: 'post',
    data: data
  });
}

/** 删除区域 */
export function platformRegionAreaDeleteApi(id) {
  return request({
    url: "/admin/platform/region/area/delete/".concat(id),
    method: 'post'
  });
}

/** 修改区域状态 */
export function platformRegionAreaStatusApi(id) {
  return request({
    url: "/admin/platform/region/area/status/".concat(id),
    method: 'post'
  });
}

/** 代理人员列表 */
export function platformRegionAgentListApi(params) {
  return request({
    url: "/admin/platform/region/agent/list",
    method: 'get',
    params: params
  });
}

/** 代理人员详情 */
export function platformRegionAgentDetailApi(id) {
  return request({
    url: "/admin/platform/region/agent/detail/".concat(id),
    method: 'get'
  });
}

/** 新增代理人员 */
export function platformRegionAgentSaveApi(data) {
  return request({
    url: "/admin/platform/region/agent/save",
    method: 'post',
    data: data
  });
}

/** 修改代理人员 */
export function platformRegionAgentUpdateApi(data) {
  return request({
    url: "/admin/platform/region/agent/update",
    method: 'post',
    data: data
  });
}

/** 删除代理人员 */
export function platformRegionAgentDeleteApi(id) {
  return request({
    url: "/admin/platform/region/agent/delete/".concat(id),
    method: 'post'
  });
}

/** 修改代理人员状态 */
export function platformRegionAgentStatusApi(id) {
  return request({
    url: "/admin/platform/region/agent/status/".concat(id),
    method: 'post'
  });
}

/** 导出代理人员 */
export function platformRegionAgentExportApi(params) {
  return request({
    url: "/admin/platform/region/agent/export",
    method: 'get',
    params: params
  });
}

/** 重置代理人员密码 */
export function platformRegionAgentResetPasswordApi(id) {
  return request({
    url: "/admin/platform/region/agent/reset/pwd/".concat(id),
    method: 'post'
  });
}

/** 代理审核列表 */
export function platformRegionAgentApplyListApi(params) {
  return request({
    url: "/admin/platform/region/agent/apply/list",
    method: 'get',
    params: params
  });
}

/** 代理审核详情 */
export function platformRegionAgentApplyDetailApi(id) {
  return request({
    url: "/admin/platform/region/agent/apply/detail/".concat(id),
    method: 'get'
  });
}

/** 代理审核通过 */
export function platformRegionAgentApplyPassApi(id) {
  return request({
    url: "/admin/platform/region/agent/apply/pass/".concat(id),
    method: 'post'
  });
}

/** 代理审核拒绝 */
export function platformRegionAgentApplyRejectApi(id, data) {
  return request({
    url: "/admin/platform/region/agent/apply/reject/".concat(id),
    method: 'post',
    data: data
  });
}

/** 代理审核撤销 */
export function platformRegionAgentApplyRevokeApi(id) {
  return request({
    url: "/admin/platform/region/agent/apply/revoke/".concat(id),
    method: 'post'
  });
}

/** 代理绑定店铺列表 */
export function platformRegionAgentStoreListApi(agentId, params) {
  return request({
    url: "/admin/platform/region/agent/store/list/".concat(agentId),
    method: 'get',
    params: params
  });
}

/** 绑定代理店铺 */
export function platformRegionAgentStoreBindApi(agentId, data) {
  return request({
    url: "/admin/platform/region/agent/store/bind/".concat(agentId),
    method: 'post',
    data: data
  });
}

/** 解绑代理店铺 */
export function platformRegionAgentStoreUnbindApi(agentId, merId) {
  return request({
    url: "/admin/platform/region/agent/store/unbind/".concat(agentId, "/").concat(merId),
    method: 'post'
  });
}

/** 提成配置详情 */
export function platformRegionCommissionConfigDetailApi(areaId) {
  return request({
    url: "/admin/platform/region/agent/commission/config/".concat(areaId),
    method: 'get'
  });
}

/** 保存提成配置 */
export function platformRegionCommissionConfigSaveApi(data) {
  return request({
    url: "/admin/platform/region/agent/commission/config/save",
    method: 'post',
    data: data
  });
}

// ==================== 区域代理后台业务接口 ====================

/** 区域代理信息 */
export function regionAgentInfoApi() {
  return request({
    url: "/admin/region/agent/info",
    method: 'get'
  });
}

/** 区域代理店铺列表 */
export function regionStoreListApi(params) {
  return request({
    url: "/admin/region/store/list",
    method: 'get',
    params: params
  });
}

/** 区域代理提成订单 */
export function regionCommissionOrderListApi(params) {
  return request({
    url: "/admin/region/commission/order/list",
    method: 'get',
    params: params
  });
}

/** 区域代理提现列表 */
export function regionWithdrawListApi(params) {
  return request({
    url: "/admin/region/withdraw/list",
    method: 'get',
    params: params
  });
}